let goodsData = [{
  "id": 1000271,
  "name": "远程控制器",
  "name_title": "环保材质、耐磨、耐油、耐久性强",
  "model": "CG023-1",
  "sku_info": [{
    "sku_id": 1000271,
    "title": "",
    "sub_title": "TPU 环保材质、耐磨、耐油、耐久性强",
    "ali_image":require('@/assets/img/products/guaLock/挂锁.jpg'),
    "spec_json": {
      "image": "attr/v2/1000271/948F029DCF134EF23267994487994DA5/",
      "show_name": "正面"
    }
  },{
    "sku_id": 1000271,
    "title": "",
    "sub_title": "TPU 环保材质、耐磨、耐油、耐久性强",
    "ali_image": require('@/assets/img/products/guaLock/挂锁.gif'),
    "spec_json": {
      "image": "attr/v2/1000271/649AD35E36A9703BACBE1555AEB6D266/",
      "show_name": "侧面"
    }
  },{
    "sku_id": 1000271,
    "title": "",
    "sub_title": "TPU 环保材质、耐磨、耐油、耐久性强",
    "ali_image":require('@/assets/img/products/guaLock/挂锁1.gif'),
    "spec_json": {
      "image": "attr/v2/1000271/07BAF8C0EF046224A84B593DEEBC869E/",
      "show_name": "安装"
    }
  },{
    "sku_id": 1000271,
    "title": "",
    "sub_title": "TPU 环保材质、耐磨、耐油、耐久性强",
    "ali_image":require('@/assets/img/products/guaLock/挂锁2.gif'),
    "spec_json": {
      "image": "attr/v2/1000271/52317E0C067C97FC6CE9376A2432CFFF/",
      "show_name": "浅金色"
    }
  }]
},{
  "id": 1000299,
  "name": "温度传感器",
  "name_title": "10000mAh 双向快充、轻盈便携、高标准安全保护",
  "model": 'CG023-3',
  "sku_info": [{
    "sku_id": 1000299,
    "title": "",
    "sub_title": "",
    "ali_image": "http://image.smartisanos.cn/resource/ae40a16324658c192c7361d829f603bd.jpg",
    "spec_json": {
      "image": "attr/v2/1000299/B37F37544921114CEF1EC01ED4DF44E4/",
      "show_name": "灰色"
    }
  }]
}]

export default goodsData



// WEBPACK FOOTER //
// ./src/lib/controllersData.js